import {
  Dispatch,
  FC,
  SetStateAction,
  SyntheticEvent,
  KeyboardEvent,
  useState,
} from 'react'
import { DropdownProps } from 'semantic-ui-react'
import { Input } from '@/componentsV1/BaseComponents'

interface UserSearchProps {
  setSearchedUserId: Dispatch<SetStateAction<number | undefined>>
  setSearchNameOrEmail: Dispatch<SetStateAction<string | undefined>>
}

const AnnualTaxFilingUserSearch: FC<UserSearchProps> = ({
  setSearchedUserId,
  setSearchNameOrEmail,
}) => {
  const [searchValue, setSearchValue] = useState<string>('')

  const clearSearch = () => {
    setSearchValue('')
    setSearchedUserId(undefined)
    setSearchNameOrEmail(undefined)
  }

  const handleUserSearch = (e: SyntheticEvent, data: DropdownProps) => {
    if (typeof data.value === 'string') {
      if (/^\d+$/.test(data.value)) {
        setSearchedUserId(parseInt(data.value, 10))
        setSearchNameOrEmail(undefined)
      } else {
        setSearchNameOrEmail(data.value)
        setSearchedUserId(undefined)
      }
    }
  }

  return (
    <div>
      <Input
        clearable
        onClearClick={clearSearch}
        type="text"
        placeholder="Search for User"
        value={searchValue}
        onChange={setSearchValue}
        onKeyUp={(e: KeyboardEvent<HTMLInputElement>) => {
          if (e.key === 'Enter') {
            handleUserSearch(e, { value: searchValue })
          }
        }}
      />
    </div>
  )
}

export default AnnualTaxFilingUserSearch
